import template from './deeplink.component.html';
import './deeplink.repository';
import './deeplink.service';
import './deeplink-error/deeplink-error.component';
import './deeplink-mobile/deeplink-mobile.component';
import './deeplink-desktop/deeplink-desktop.component';

angular
    .module('Toke')
    .component('appDeeplink', {
        template,
        controller: DeeplinkController
    });

DeeplinkController.$inject = ['deeplinkRepository', 'deeplinkService'];

function DeeplinkController(deeplinkRepository, deeplinkService) {

    const vm = this;

    vm.deeplinkData = {};
    vm.state = {};

    vm.$onInit = function () {
        deeplinkRepository
            .getDeeplinkData()
            .then(res => {
                vm.deeplinkData = res;
                initializeState();
            });
    };

    function initializeState() {
        const params = deeplinkService.getQueryParams();
        const config = vm.deeplinkData.config;

        vm.state = {
            loaded: true,
            params,
            currentUrl: deeplinkService.getCurrentUrl(),
            isMobile: deeplinkService.isMobile(),
            isValid: deeplinkService.validateParams(params, config),
            errors: deeplinkService.getValidationErrors(params, config)
        };
    }
}